import { CommonModule, NgFor, NgIf, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GalleriaModule } from 'primeng/galleria';

// import { search_filter } from '../../../_model/search_fliter';
// import { DatasearchService } from '../../_services/datasearch.service';
// import { ExportDataService } from '../../_services/export-data.service';
// import { user_privilege } from '../../../_model/user_privilege';
// import { AuthenticationService } from '../../_services/authentication.service';
// import { ConstantService } from '../../_services/constant.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import * as bootstrap from 'bootstrap';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { BusyService } from '../../../_services/busy.service';
import { DatasearchService } from '../../../_services/datasearch.service';
import { ExportDataService } from '../../../_services/export-data.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { ConstantService } from '../../../_services/constant.service';
import { user_privilege } from '../../../../_model/user_privilege';
import { search_filter } from '../../../../_model/search_fliter';
import { CommanService } from '../../../_services/comman.service';
type SidebarOption =
  | 'Data Availability'
  | 'description'
  | 'Product Identification'
  | 'Physicochemical (Computed Properties)'
  | 'Physicochemical (Experimental Properties)'
  | 'Invent Info'
  | '   History / Development / licencing / Commercialisation'
  | 'Litigation / Opposition / Inter Partes Review  '
  | 'Jarvis Patent Landscape'
  | 'Jarvis-Non-Patent References'
  | 'Biology'
  | 'Approval Status'
  | 'Country wise regulatory information'
  | 'Product-Exclusivity'
  | 'Impurities'
  | 'Formulation Types'
  | 'Formulations / Preparations'
  | 'Analytical Data'
  | 'Toxicity Data'
  | 'Mammalian Toxicology '
  | 'Mammalian - Human Tox'
  | 'Supplementary Protection Certificate (Spc)'
  | 'Data Protection (Solo Product)'
  | 'Key Starting Material (KSM)'
  | 'Environmental Fate'
  | 'Dissipation Studies'
  | 'Soil Adsorption And Mobility Studies'
  | 'Photolytic Decomposition'
  | 'Metabolites'
  | 'Safety Data'
  | 'Sales Data (Sales / Year ($m.))'
  | 'Supplier (S) / Chemical Vendors'
  | 'Pricing'
  | 'Product Technologies'
  | 'Literature'
  | 'holder'
  | 'link'
  | 'dummy';
@Component({
  selector: 'app-product-information',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    CommonModule,
    GalleriaModule,
    ToastModule,
    RouterModule,
  ],
  templateUrl: './product-information.component.html',
  styleUrl: './product-information.component.scss',
})
export class ProductInformationComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  rows!: number;
  currGBRN: any = 0;
  dataAvailablity: any[] = [];
  isAdmin: boolean = false;
  TableName: string = 'basic_product_details_MONGO';
  pageTitile = 'QuikPatent';
  isSignedIn = false;
  data: any[] = [];
  allData: any[] = [];
  current_pagenumber: number = 1;
  Default_DownloadRec_Limit: number = 500;
  maxWords: number = 80;
  maxLines: number = 9.5; // Max lines to display before truncating
  readMoreText: string = 'Read More';
  readLessText: string = 'Read Less';
  currentFilterCondition: any = [];
  filteredSidebarOptions: SidebarOption[] = [];
  currentSortBy: string = '';
  application_query: string = '';
  search_filters!: search_filter;
  updatePrivilege = true;
  user_ip: string = '';
  address: string = '';
  transparent = true;
  user_data: any;
  additionalOperator: string = '';
  rptDataForExcel: any = [];
  listener: (() => void) | undefined;
  cols: any[] = [];
  isVisible = false;
  columns: any[] = [];
  userid: any[] = [];
  fullImageUrl: string | null = null;
  moaImageUrl: string | null = null;
  keggImageUrl: string | null = null;
  searchQueryGrid: string[] = [];
  totalRecords: number = 0;
  oldRecords: number = 0;
  gbrnArray: string[] = []; // Declare gbrnArray property as an array of strings
  INCHIKEY: string = '';
  inchiKeyArray: string[] = []; // Declare userId as an array of strings
  privilege_json!: user_privilege;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  introVideo =
    'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-Agrochemical-Pharmaceutical-Fine-Chemical-Database-Patents.mp4';
  constructor(
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private busyService: BusyService,
    private datasearch: DatasearchService,
    private exportdataService: ExportDataService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private commanService: CommanService
  ) {}

  // Sidebar functionality
  isSidebarOpen = false;
  selectedOption: number | null = null; // Track selected option
  displayBasic: boolean = false; // To control visibility of the gallery dialog
  images: any[] = [];
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  @HostListener('document:copy', ['$event'])
  disableCopy(event: ClipboardEvent) {
    event.preventDefault();
  }

  @HostListener('document:contextmenu', ['$event'])
  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }
  sidebarOptions: SidebarOption[] = [
    'Data Availability',
    'description',
    'Product Identification',
    'Physicochemical (Computed Properties)',
    'Physicochemical (Experimental Properties)',
    'Invent Info',
    '   History / Development / licencing / Commercialisation',
    'Litigation / Opposition / Inter Partes Review  ',
    'Jarvis Patent Landscape',
    'Jarvis-Non-Patent References',
    'Biology',
    'Approval Status',
    'Country wise regulatory information',
    'Product-Exclusivity',
    'Impurities',
    'Formulation Types',
    'Formulations / Preparations',
    'Analytical Data',
    'Toxicity Data',
    'Mammalian Toxicology ',
    'Mammalian - Human Tox',
    'Supplementary Protection Certificate (Spc)',
    'Data Protection (Solo Product)',
    'Key Starting Material (KSM)',
    'Environmental Fate',
    'Dissipation Studies',
    'Photolytic Decomposition',
    'Soil Adsorption And Mobility Studies',

    'Metabolites',
    'Safety Data',
    'Sales Data (Sales / Year ($m.))',
    'Supplier (S) / Chemical Vendors',
    'Pricing',
    'Product Technologies',
    'Literature',
    'holder',
    'link',
    'dummy',
  ];
  readonly sectionIdMap: Record<SidebarOption, string | string[]> = {
    'Data Availability': [
      'summaryPhysicochemPropExperi',
      'isomerism',
      'polymorphism',
      'description',
      'meltingPointC',
      'boilingPointC',
      'degradationPointC',
      'flashpointC',
      'freezingPointC',
      'agueousSolubilityMgL',
      'solubilityInOrganicSolventsMgL',
      'solubilityInNHeptaneMgL',
      'solubilityInMethanolMgL',
      'solubilityInAcetoneMgL',
      'solubilityInEthylAcetateMgL',
      'solubilityInOtherOrganicSolventsMgL',
      'densityGMl',
      'bulkDensityGMlSpecificGravity',
      'vapourPressure',
      'logpOctanolWater',
      'stability',
      'pkaDissociationConstants',
      'henrysLawConstantAt25Cpam3Mol1',
      'maximumUvVisAbsorptionLMolCm',
      'SURFACE_TENSION',
    ],
    description: 'description',
    'Product Identification': 'gbrn',
    'Physicochemical (Computed Properties)': 'summaryPhysicochemPropComp',
    'Physicochemical (Experimental Properties)': [
      'summaryPhysicochemPropExperi',
      'isomerism',
      'polymorphism',
      'description',
      'meltingPointC',
      'boilingPointC',
      'degradationPointC',
      'flashpointC',
      'freezingPointC',
      'agueousSolubilityMgL',
      'solubilityInOrganicSolventsMgL',
      'solubilityInNHeptaneMgL',
      'solubilityInMethanolMgL',
      'solubilityInAcetoneMgL',
      'solubilityInEthylAcetateMgL',
      'solubilityInOtherOrganicSolventsMgL',
      'densityGMl',
      'bulkDensityGMlSpecificGravity',
      'vapourPressure',
      'logpOctanolWater',
      'stability',
      'pkaDissociationConstants',
      'henrysLawConstantAt25Cpam3Mol1',
      'maximumUvVisAbsorptionLMolCm',
      'SURFACE_TENSION',
    ],
    'Invent Info': [
      'inventInfo',
      'inventInfo3',
      'innovatorOriginator',
      'nonPatent',
      'phytotoxicity',
      'dummy7',
    ],
    '   History / Development / licencing / Commercialisation':
      'histDevLicnComm',
    'Litigation / Opposition / Inter Partes Review  ':
      'litigationOppIprMhReexam',
    'Jarvis Patent Landscape': [
      'summaryPatentLandscape',
      'googlePatentHyperlinkOfPatentInventInfo',
    ],
    'Jarvis-Non-Patent References': 'JARVIS_NON_PATENT_REFERENCES',
    Biology: [
      'moaImage',
      'keggImage',
      'summaryOfBiology',
      'indication',
      'uses',
      'MAXIMUM_RESIDUE_LEVEL_MRL',
      'mechanismOfActionMoa',
      'spectrumPestPathogen',
      'mainPests',
      'PEST_RESURGENCE',
      'crop',
      'applicationTiming',
      'dosages',
      'phytotoxicity',
    ],
    'Approval Status': 'summaryApprovalStatus',
    'Country wise regulatory information': [
      'euPesticidesData',
      'euPesticidesData',
      'ukLerapStatus',
      'usdaPesticideDataProgram',
      'FDA_REQUIREMENTS',
      'examplesOfRecordedResistance',
      'resistanceActionCommitteeRacFracHracIrac',
      'herbicideResistanceClassificationWssa',
    ],
    'Product-Exclusivity': [
      'europeSupProtCertifiSpc',
      'otherCountriesSupProtCertifiSpc',
      'exclusivityNewChemicalEntity',
      'orphanDrugExclusivityOde',
      'pediatricDrugExclusivityPde',
      'nceMinusOrQidpMinus',
      'europeExclusivity',
      'canadaExclusivity',
      'otherCountriesExclusivities',
      'orangeBookPatents',
    ],
    Impurities: [
      'summaryImpuritiesAsPerEpReviewReport',
      'impuritiesAsPerEpReviewReport',
    ],
    'Formulation Types': ['summaryFormulationTypes', 'formulationGlobally'],
    'Formulations / Preparations': [
      'summaryFormulationsPreparations',
      'keyManufacturerBrand',
      'manufacturers',
    ],
    'Analytical Data': 'analyticalData',
    'Toxicity Data': ['toxicityEpaClass', 'toxicologicalEnvironmentalReviews'],
    'Mammalian Toxicology ': [
      'mammalianNonHumanAnimalsTox',
      'summaryOfMammalianToxicology',
      'chronic',
      'dermal',
      'birdsAcuteLd50MgKg',
      'fishAcute96HourLc50MgL',
    ],
    'Mammalian - Human Tox': [
      'summaryOfMammalianHumanTox',
      'mammalsAcuteOralLd50MgKg',
      'mammalsDermalLd50MgKgBodyWeight',
      'mammalsInhalationLc50MgL',
      'mammalsShortTermDietaryNoelMgKg',
      'mammalsShortTermDietaryNoelPpmDiet',
      'adiAcceptableDailyIntakeMgKgBwPerDay',
      'arfdAcuteReferenceDoseMgKgBwPerDay',
      'aoelAcceptableOperatorExposureLevelSystemicMgKgBwPerDay',
      'exposureRoutesPublic',
      'exposureRoutesOccupational',
    ],
    'Supplementary Protection Certificate (Spc)':
      'SUPPLEMENTARY_PROTECTION_CERTIFICATE',
    'Data Protection (Solo Product)': 'dataProtection',
    'Key Starting Material (KSM)': 'keyStartingMaterialUsedInGivenProcessKsm',
    'Environmental Fate': ['summaryOfEnvironmentalFate', 'soilDegradation'],
    'Dissipation Studies': [
      'dissipationRateRl50OnPlantMatrixRateGHa',
      'dissipationRateRl50OnAndInPlantMatrix',
      'waterSedimentDt50Days',
      'waterPhaseOnlyDt50Days',
    ],
    'Photolytic Decomposition': [
      'agueousPhotolysisDt50DaysAtPh7',
      'agueousHydrolysisDt50DaysAt20CAndPh7',
    ],
    'Soil Adsorption And Mobility Studies': [
      'soilAdsorptionCoefficientKd',
      'soilAdsorptionCoefficientKoc',
      'freundlichAdsorptionCoefficientKf',
      'organicCarbonNormalizedFreundlichAdsorptionCoefficientKfoc',
      'freundlichExponent1N',
      'PH',
    ],
    Metabolites: ['metabolites', 'metabolites'],
    'Safety Data': 'SAFETY_DATA',
    'Sales Data (Sales / Year ($m.))': [
      'summarySalesDataSalesYearM',
      'salesData',
      'competitors',
    ],
    'Supplier (S) / Chemical Vendors': 'SUPPLIERS',
    Pricing: 'PRICING',
    'Product Technologies': 'keyTechnologies',
    Literature: ['informationSources', 'remarks'],
    holder: ['usdmfHolder', 'EP_DMF_HOLDER', 'otherDmfHolder'],
    link: ['LINK1', 'LINK2', 'LINK3', 'LINK4', 'LINK5', 'LINK6'],
    dummy: [
      'dummy1',
      'dummy2',
      'dummy3',
      'dummy4',
      'dummy5',
      'dummy6',
      'dummy7',
      'dummy8',
      'dummy9',
      'dummy10',
      'dummy11',
      'dummy12',
      'dummy13',
      'dummy14',
    ],
  };
  selectOption(index: number) {
    this.selectedOption = index; // Set selected option index
  }

  // Scroll functionality to navigate to specific sections
  highlightedIndex: number | null = null;
  scrollToSection(sectionKey: SidebarOption, index: number): void {
    const sectionIdMap: Record<SidebarOption, string> = {
      'Data Availability': 'dataAvailablity',
      description: 'description',
      'Product Identification': 'gbrn',
      'Physicochemical (Computed Properties)': 'physicochemical-computed',
      'Physicochemical (Experimental Properties)':
        'physicochemical-experimental',
      'Invent Info': 'invent-info',
      '   History / Development / licencing / Commercialisation': 'HISTORY',
      'Litigation / Opposition / Inter Partes Review  ': 'LITIGATION',
      'Jarvis Patent Landscape': 'summaryPatentLandscape',
      'Jarvis-Non-Patent References': 'jarvis-non-patent-references',
      Biology: 'biology',
      'Approval Status': 'approval-status',
      'Country wise regulatory information': 'country-wise',
      'Product-Exclusivity': 'product-EXCLUSIVITY',
      Impurities: 'impurities',
      'Formulation Types': 'formulation-types',
      'Formulations / Preparations': 'formulations-preparations',
      'Analytical Data': 'analytical-data',
      'Toxicity Data': 'toxicity-data',
      'Mammalian Toxicology ': 'mammalian-toxicology',
      'Mammalian - Human Tox': 'mammalian-human-tox',
      'Supplementary Protection Certificate (Spc)':
        'supplementary-protection-certificate',
      'Data Protection (Solo Product)': 'data-protection-solo-product',
      'Key Starting Material (KSM)': 'key-starting-material',
      'Environmental Fate': 'environmental-fate',
      'Dissipation Studies': 'DISSIPATION-STUDIES',
      'Photolytic Decomposition': 'PHOTOLYTIC-DECOMPOSITION',
      'Soil Adsorption And Mobility Studies':
        'SOIL-ADSORPTION-AND-MOBILITY-STUDIES',
      Metabolites: 'metabolites',
      'Safety Data': 'safety-data',
      'Sales Data (Sales / Year ($m.))': 'sales-data',
      'Supplier (S) / Chemical Vendors': 'supplier-chemical-vendors',
      Pricing: 'pricing',
      'Product Technologies': 'product-technologies',
      Literature: 'literature',
      holder: 'holder',
      link: 'link',
      dummy: 'dummy',
    };
    const sectionIds = sectionIdMap[sectionKey];

    if (!sectionIds) {
      console.error(`No section ID found for key: ${sectionKey}`);
      return;
    }

    const ids = Array.isArray(sectionIds) ? sectionIds : [sectionIds];

    let found = false;

    ids.forEach((id) => {
      const matchingElements = document.querySelectorAll(`#${id}`);
      if (matchingElements.length > 0) {
        found = true;
        // Scroll to the first matching element
        const targetElement = matchingElements[0] as HTMLElement;

        // Smooth scroll to the element
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Prevent the main window from scrolling
        window.scrollTo(0, 0);

        // Highlight the section for better visual feedback
        this.highlightedIndex = index;
        targetElement.classList.add('flash-highlight'); // Add highlight class

        // Remove highlight class after a short delay
        setTimeout(() => {
          targetElement.classList.remove('flash-highlight');
        }, 1000);
      }
    });

    if (!found) {
      console.error(
        `No matching elements found for section IDs: ${ids.join(', ')}`
      );
    }
  }

  /**
   * Checks if a column is configured to be visible and has a value in any record of the current dataset.
   */
  hasColumnValue(key: string): boolean {
    return Array.isArray(this.data) && this.data.some(item => this.isColumnVisible(item, key));
  }

  /**
   * Scrolls smoothly to a specific subheading inside the "Invent Info" section
   * and ensures the main "Invent Info" sidebar item remains selected/highlighted.
   */
  scrollToSubSection(subSectionId: string): void {
    const targetElement = document.getElementById(subSectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Prevent main window scrolling
      window.scrollTo(0, 0);

      // Maintain the parent "Invent Info" highlight in the sidebar
      const inventInfoIndex = this.filteredSidebarOptions.indexOf('Invent Info');
      if (inventInfoIndex !== -1) {
        this.highlightedIndex = inventInfoIndex;
      }

      // Flash-highlight effect
      targetElement.classList.add('flash-highlight');
      setTimeout(() => {
        targetElement.classList.remove('flash-highlight');
      }, 1000);
    } else {
      console.error(`Sub-section ID not found: ${subSectionId}`);
    }
  }

  ngOnInit(): void {
    this.authentication.getCurrentUserValue().subscribe((user: any) => {
      this.user_data = user;
    });
    this.listener = this.renderer.listen(
      'document',
      'keydown',
      (event: KeyboardEvent) => {
        if (
          (event.ctrlKey || event.metaKey) &&
          event.key.toLowerCase() === 'p'
        ) {
          event.preventDefault();
        }
      }
    );

    this.commanService.productInformationData.subscribe((res: any) => {
      this.data = res?.data || {}; // Default to empty object if no data is passed
      this.allData = res?.allData || {};
      this.userid = res?.userid || []; // Default to empty array if no userId is passed
      this.gbrnArray = res?.gbrnArray || []; // Assign gbrnArray or default to empty array
      this.inchiKeyArray = res?.inchiKeyArray || []; // Assign inchiKeyArray or default to empty array
      this.privilege_json = res?.privilege_json || {};
      this.currentFilterCondition = res?.currentFilterCondition || [];
      this.application_query = res?.application_query || ''; // Default to empty string if no value is passed
      this.search_filters = res?.search_filters || {};
      this.cols = res?.cols || {}; // Default to empty object or appropriate default
      this.columns = res?.columns || []; // Assign columns or default to an empty array
      this.searchQueryGrid = res?.searchQueryGrid || null;
      this.totalRecords = res?.totalRecords || 0;
      this.oldRecords = res?.oldRecords;
      this.currGBRN = res?.gbrn || 0;
    });

    if (this.data && Array.isArray(this.data)) {
      this.data = this.data.map((item: any) => {
        const filteredItem: any = {};

        // Iterate over each key in the object
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            filteredItem[key] =
              typeof item[key] === 'string'
                ? item[key].replace(/\r/g, '') // Replace '\r' with an empty string
                : item[key]; // Keep non-string values unchanged
          }
        }
        return filteredItem;
      });
    } else {
      console.warn('Unexpected format for `data`:', this.data);
    }

    if (Array.isArray(this.cols)) {
    } else if (typeof this.cols === 'object' && this.cols !== null) {
      // Convert object to an array format if needed
      this.cols = Object.keys(this.cols).map((key) => ({
        field: key,
        value: this.cols,
      }));
    } else {
      console.warn('Unexpected format for `cols`:', this.cols);
    }
    // Handle additional logic for columns if needed
    if (this.columns && this.columns.length > 0) {
      this.columns.forEach((col) => {
        // Add additional processing for each column if needed
      });
    }
    this.datasearch.dataAvailablity(this.currGBRN).subscribe(
      (res: any) => {
        this.dataAvailablity = res.data.data;
      },
      (error) => {
        console.log(error);
      }
    );
    this.updateSidebarOptions();
    this.getcolumnsdiscovery();
  }
  updateSidebarOptions(): void {
    this.filteredSidebarOptions = this.sidebarOptions.filter((option) => {
      const key = this.sectionIdMap[option];

      if (Array.isArray(key)) {
        // If the key is an array, check if any of the keys have available data
        return key.some((k) => this.data.some((item) => item[k]));
      } else {
        // If the key is a single string, check it directly
        return this.data.some((item) => item[key]);
      }
    });
  }

  goBack(): void {
    this.totalRecords = this.data.length; // Ensure totalRecords is updated
    this.router.navigate(['/search'], {
      state: {
        allData: this.allData,
        userid: this.userid,
        gbrnArray: this.gbrnArray,
        inchiKeyArray: this.inchiKeyArray,
        privilege_json: this.privilege_json,
        currentFilterCondition: this.currentFilterCondition,
        application_query: this.application_query,
        search_filters: this.search_filters,
        cols: this.cols,
        columns: this.columns,
        searchQueryGrid: this.searchQueryGrid,
        totalRecords: this.totalRecords,
        oldRecords: this.oldRecords,
      },
    });
  }

  ngOnDestroy(): void {
    if (this.listener) {
      this.listener();
    }
  }
  ngAfterViewInit(): void {
    const paragraphs =
      this.el.nativeElement.querySelectorAll('.product-info p');

    paragraphs.forEach((p: HTMLElement) => {
      const fullText = p.innerHTML || '';
      const words = fullText.split(' '); // Split the text into words
      const maxWordCount = this.maxWords; // maxWords should be defined elsewhere in your component

      if (words.length > maxWordCount) {
        // Truncate text by words
        const truncatedText = words.slice(0, maxWordCount).join(' ') + '...';

        // Set the initial truncated text
        this.renderer.setProperty(
          p,
          'innerHTML',
          this.transformNewLines(truncatedText)
        );

        // Create "Read More" button
        const readMoreButton = this.renderer.createElement('button');
        this.renderer.addClass(readMoreButton, 'read-more-btn');
        this.renderer.setProperty(
          readMoreButton,
          'textContent',
          this.readMoreText
        );

        // Append the button to the paragraph
        this.renderer.appendChild(p, readMoreButton);

        // Toggle between full text and truncated text
        let isExpanded = false;
        this.renderer.listen(readMoreButton, 'click', () => {
          isExpanded = !isExpanded;

          if (isExpanded) {
            // Expand: Show full text
            this.renderer.setProperty(
              p,
              'innerHTML',
              this.transformNewLines(fullText)
            );
            this.renderer.setProperty(
              readMoreButton,
              'textContent',
              this.readLessText
            );

            // Avoid scrolling on "Read More"
            this.renderer.appendChild(p, readMoreButton);
          } else {
            // Collapse: Show truncated text
            this.renderer.setProperty(
              p,
              'innerHTML',
              this.transformNewLines(truncatedText)
            );
            this.renderer.setProperty(
              readMoreButton,
              'textContent',
              this.readMoreText
            );

            // Reappend the button to avoid removal
            this.renderer.appendChild(p, readMoreButton);

            // Scroll to the paragraph's relevant space
            p.scrollIntoView({
              behavior: 'smooth', // Smooth scrolling
              block: 'center', // Scroll the element to the center of the view
            });
          }
        });
      }
    });
  }

  // Function to truncate text based on max lines
  truncateTextByLines(
    element: HTMLElement,
    text: string,
    maxHeight: number
  ): string {
    let truncatedText = text;

    // Create a temporary element for simulation
    const tempElement = this.renderer.createElement('div');
    this.renderer.setStyle(tempElement, 'position', 'absolute');
    this.renderer.setStyle(tempElement, 'visibility', 'hidden');
    this.renderer.setStyle(tempElement, 'width', `${element.offsetWidth}px`);
    this.renderer.setStyle(
      tempElement,
      'line-height',
      window.getComputedStyle(element).lineHeight
    );
    this.renderer.appendChild(document.body, tempElement);

    // Build the truncated text
    const words = text.split(' ');
    let truncated = '';
    for (const word of words) {
      truncated += word + ' ';
      this.renderer.setProperty(tempElement, 'innerHTML', truncated);
      if (tempElement.offsetHeight > maxHeight) {
        truncatedText = truncated.trim() + '...';
        break;
      }
    }

    // Clean up the temporary element
    document.body.removeChild(tempElement);

    return truncatedText;
  }

  onImageError(event: any) {
    // Replace the broken image with the text "inventorLogo"
    const textNode = document.createElement('span');
    textNode.style.width = '300px';

    // Replace the image with the text "inventorLogo"
    event.target.replaceWith(textNode);
  }
  // @HostListener('window:resize', ['$event'])
  // onResize(event: any) {
  //   if (window.innerWidth > 768) {
  //     // Automatically open the sidebar for large screens
  //     this.isSidebarOpen = true;
  //   } else {
  //     // Close the sidebar for smaller screens
  //     this.isSidebarOpen = false;
  //   }
  // }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen; // Toggle sidebar visibility
  }

  getFirstPart(synonyms: string): string[] {
    // Ensure it's split into an array and get the first 10 items
    return synonyms?.split(',').slice(0, 10) || [];
  }

  getSecondPart(synonyms: string): string[] {
    // Ensure it's split into an array and get items from 11 to 20
    return synonyms?.split(',').slice(10, 20) || [];
  }
  // Utility function to handle new lines in text
  transformNewLines(text: string) {
    return text ? text.replace(/\n/g, '<br>') : '';
  }
  ImageFullView(item: any): void {
    this.fullImageUrl =
      'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
      item.chemicalStructure;
    const modal = new bootstrap.Modal(document.getElementById('imageModal')!);
    modal.show();
  }
  keggFullView(item: any): void {
    this.keggImageUrl = `https://www.chemrobotics.com/agropat/images/ghs_pictograms/${item.keggImage}`;
    const modal = new bootstrap.Modal(document.getElementById('keggModal')!);
    modal.show();
  }

  MoaFullView(item: any): void {
    this.moaImageUrl = `https://www.chemrobotics.com/agropat/images/ghs_pictograms/${item.moaImage}`;
    const modal = new bootstrap.Modal(document.getElementById('moaModal')!);
    modal.show();
  }

  exportExcel(extension: string): void {
    // console.log('📥 Export initiated with extension:', extension);

    this.busyService.busy();

    const postdata = {
      tablename: this.TableName,
      filterconditionQuikPatent: this.currentFilterCondition,
      pagenumber: this.current_pagenumber,
      rowscount: 500,
      sortby: this.currentSortBy,
      application_query: this.application_query,
      updatePrivilege: this.updatePrivilege,
      search_filters: this.search_filters,
      user_ip: this.user_ip || null,
      address: this.address || null,
      userid: this.userid,
      columns: this.columns,
      searchQueryGrid: this.searchQueryGrid,
    };

    // console.log('📤 Sending post data for export:', postdata);

    this.datasearch.get_suite_data(postdata).subscribe({
      next: (response: any) => {
        // console.log('✅ Raw response received:', response);

        const DownloadData: any[] = response[0] || []; // ✔️ Fixed: Access data from index 0
        // console.log('📦 Raw download data:', DownloadData);

        this.rptDataForExcel = [];

        const cols = this.columns || [];
        const displayedColumns = cols
          .filter((col: any) => Number(col.isDisplay) === 1)
          .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

        const fields: string[] = displayedColumns.map(
          (col: any) => col.tableColumnName
        );
        const headers: string[] = displayedColumns.map(
          (col: any) =>
            col.displayColumnName || col.excelColumnName || col.tableColumnName
        );

        const nonEmptyFields = fields.filter((field: string) => {
          return DownloadData.some((row: any) => {
            if (row.gbrn_products?.length > 0) {
              return row.gbrn_products.some((prod: any) => prod[field]);
            }
            return row[field];
          });
        });

        const filteredHeaders = displayedColumns
          .filter((col: any) => nonEmptyFields.includes(col.tableColumnName))
          .map(
            (col: any) =>
              col.displayColumnName ||
              col.excelColumnName ||
              col.tableColumnName
          );

        const filteredDataRows = DownloadData.filter((row: any) => {
          return nonEmptyFields.some((field: string) => {
            if (row.gbrn_products?.length > 0) {
              return row.gbrn_products.some((prod: any) => prod[field]);
            }
            return row[field];
          });
        });

        filteredDataRows.forEach((row: any, index: number) => {
          row.S_NO = index + 1;
          const rowData = nonEmptyFields.map((field: string) => {
            if (row.gbrn_products?.length > 0) {
              const gbrnProduct = row.gbrn_products[0];
              if (gbrnProduct.hasOwnProperty(field)) {
                return gbrnProduct[field];
              }
            }
            return row[field];
          });
          this.rptDataForExcel.push(rowData);
        });

        console.log('✅ Displayed Headers:', filteredHeaders);
        console.log('📊 Final export data:', this.rptDataForExcel);

        const reportData = {
          title: 'Agropat Discovery-suite  Data Report',
          data: this.rptDataForExcel,
          headers: filteredHeaders,
          sheetname: 'data',
          file_extention: extension,
          searchterm: this.searchQueryGrid,
        };

        console.log('📁 Preparing to export with reportData:', reportData);

        this.exportdataService.exportExcel(reportData);
      },
      error: (error: any) => {
        console.error('❌ Error during data fetch for export:', error);
        this.busyService.idle();
      },
      complete: () => {
        console.log('✅ Export process completed.');
        this.busyService.idle();
      },
    });
  }

  //   exportPdf() {
  //     console.log('Starting exportPdf function.');

  //     // Check User Privilege
  //     if (!this.checkUserDownloadPrivillege()) {
  //       console.log('User does not have download privileges.');
  //       return;
  //     }

  //     this.busyService.busy();
  //     console.log('Set busy state.');

  //     if (this.currentFilterCondition.length == 0) {
  //       console.log('No filter condition found.');
  //       this.busyService.idle();
  //       return;
  //     }

  //     console.log('Preparing postdata for API call.');
  //     let postdata = {
  //       mode: 'EXPORT_DATA',
  //       tablename: this.TableName,
  //       filtercondition: this.currentFilterCondition,
  //       filterconditionQuikPatent: this.currentFilterCondition,
  //       pagenumber: this.current_pagenumber,
  //       rowscount: this.Default_DownloadRec_Limit,
  //       sortby: this.currentSortBy,
  //       application_query: this.application_query,
  //       search_filters: this.search_filters,
  //       user_ip: this.user_ip ? this.user_ip : null,
  //       address: this.address ? this.address : null,
  //       userid: this.userid,
  //     };

  //     console.log('Postdata:', postdata);

  //     this.datasearch.get_suite_data(postdata).subscribe(
  //       (response: any) => {
  //         console.log('API response received:', response);

  //         let DownloadData = response[0];
  //         this.rptDataForExcel = [];

  //         console.log('Filtering columns for export.', this.columns);
  //         let columns = this.cols
  //           .filter((x) => x.isDisplay == 1)
  //           .map((col) => ({
  //             title: col.header,
  //             dataKey: col.field,
  //           }));

  //         console.log('Sorting DownloadData based on priority and applicationDate.');
  //         DownloadData.sort((a: any, b: any) => {
  //           if (a.priority === '' && b.priority !== '') {
  //             return 1;
  //           } else if (a.priority !== '' && b.priority === '') {
  //             return -1;
  //           } else {
  //             const priorityComparison = a.priority - b.priority;
  //             if (priorityComparison !== 0) {
  //               return priorityComparison;
  //             } else {
  //               if (a.applicationDate === null && b.applicationDate !== null) {
  //                 return 1;
  //               } else if (
  //                 a.applicationDate !== null &&
  //                 b.applicationDate === null
  //               ) {
  //                 return -1;
  //               } else {
  //                 return (
  //                   new Date(a.applicationDate).getTime() -
  //                   new Date(b.applicationDate).getTime()
  //                 );
  //               }
  //             }
  //           }
  //         });

  //         console.log('Adding serial numbers to DownloadData.', DownloadData);
  //         DownloadData.forEach((row: any, index: any) => {
  //           row.S_NO = index + 1;
  //         });

  //         console.log('this.colsthis.colsthis.cols.', this.cols);
  //         DownloadData.forEach((row: any) => {
  //           let rowValues: any = [];
  //           this.cols.forEach((col) => {
  //             rowValues.push(row[col.field]);
  //           });
  //           this.rptDataForExcel.push(rowValues);
  //         });
  //         console.log('Mapping data for export.', this.rptDataForExcel);
  // console.log("columns coming in header???????",columns)
  //         let reportData = {
  //           title: `${this.pageTitile} Data Report`,
  //           data: this.rptDataForExcel,
  //           headers: this.columns,
  //           sheetname: 'data',
  //         };

  //         console.log('Exporting data to PDF.', reportData);
  //         this.exportdataService.exportPdf(reportData);
  //         this.busyService.idle();
  //         console.log('Export complete. Set idle state.');
  //       },
  //       (error: any) => {
  //         console.error('Error occurred during API call:', error);
  //         this.busyService.idle();
  //       },
  //       () => {
  //         console.log('ExportPdf operation completed.');
  //         this.busyService.idle();
  //       }
  //     );
  //   }
  //  async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserSubject().subscribe((val) => {
  //     this.user_data = val;

  //     this.authentication
  //       .getUserPrivilege({
  //         mode: 'GET_USER_PRIVILEGE',
  //         userid: val.userid,
  //         app_json_name: 'agropat-ultimate-discovery-suite-beta ',
  //         application_name: 'agropat-ultimate-discovery-suite-beta Platform',
  //       })
  //       .subscribe({
  //         next: async (res: any) => {
  //           // Process privilege_json
  //           this.privilege_json = this._constant.getAppprivilege(
  //             res.privilege_json,
  //             'agropat-ultimate-discovery-suite-beta',
  //             val.userid
  //           );
  //           // Emit the data using a new EventEmitter
  //           // this.emitUserPrivilege.emit({
  //           //   privilege_json: this.privilege_json,
  //           //   userid: val.userid,
  //           //   keyword: this.route.snapshot.params['keyword'] || '',
  //           // });

  //           // this.commanService.currentPrivilege.next({
  //           //   privilege_json: this.privilege_json,
  //           //   userid: val.userid,
  //           //   keyword: this.route.snapshot.params['keyword'] || '',
  //           // });

  //           // Handle keyword logic
  //           // if (this.route.snapshot.params['keyword']) {
  //           //   this.staticSuggestion(
  //           //     'keyword',
  //           //     '',
  //           //     this.route.snapshot.params['keyword']
  //           //   );
  //           // }
  //         },
  //         error: (err) => {
  //           console.error('Error fetching privilege JSON:', err);
  //         },
  //       });
  //   });
  // }
  showToast() {
    this.messageService.add({
      severity: 'info ',
      summary: 'Coming Soon',
      detail: 'This feature is coming soon!',
    });
  }
  scrollToTop() {
    const sidebar = document.querySelector('.card'); // Replace with your sidebar's class or ID
    if (sidebar) {
      sidebar.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  copyToClipboardFormattedDate(value: any): void {
    const formattedDate = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format the date
    if (formattedDate) {
      this.copyToClipboard(formattedDate); // Call your existing copy function
    }
  }
  copyToClipboard(value: string): void {
    // console.log('Attempting to copy value:', value); // Log the value being copied

    // Use the Clipboard API to copy the text
    navigator.clipboard
      .writeText(value)
      .then(() => {
        // Log success to the console
        // console.log('Successfully copied:', value);

        // Show the success toast notification using PrimeNG's MessageService
        this.messageService.add({
          severity: 'success',
          summary: 'Copied to Clipboard',
          detail: value,
        });
      })
      .catch((err) => {
        // Log error to the console
        console.error('Failed to copy text:', err);

        // Show an error notification if clipboard operation fails
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to Copy',
          detail: 'There was an error copying the text.',
        });
      });
  }

  checkUserDownloadPrivillege(): boolean {
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    if (todayDownloadCount >= dailyDownloadLimit) {
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    if (downloadCount <= 0) {
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    return true;
  }

  navigateToUrl(link: string) {
    // Define the base URL for the patent link
    const baseUrl = 'https://patents.google.com/patent/';

    // Construct the full URL by appending the link to the base URL
    const finalUrl = baseUrl + link.trim();

    // Log the constructed URL for debugging purposes
    // console.log('Navigating to:', finalUrl);

    // Open the link in a new tab
    window.open(finalUrl, '_blank');
  }
  navigateToWebsite(buttonType: string, productIndex: number): void {
    const accessKey = 'MTA5Ng%3D%3D';
    // Check if 'gbrnArray' and 'inchiKeyArray' exist and the specific product index is valid
    if (
      this.gbrnArray &&
      this.gbrnArray[productIndex] &&
      this.inchiKeyArray &&
      this.inchiKeyArray[productIndex]
    ) {
      // Get the gbrn and INCHIKEY values for the specific product
      const gbrn = this.gbrnArray[productIndex];
      const inchiKey = this.inchiKeyArray[productIndex];
      let url = '';

      switch (buttonType) {
        case 'gasp':
          url = `https://www.chemrobotics.com/pesticides-directory/index_gbrn1.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'ibd':
          url = `https://www.chemrobotics.com/agropat-ultimate/ipd-list.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'mrl':
          url = `https://www.chemrobotics.com/agropat-ultimate/mrl-list.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'wipo':
          // Use the INCHIKEY for the 'wipo' URL
          url = `https://patentscope.wipo.int/search/en/result.jsf?access_key=${accessKey}&inchikey=${inchiKey}`;
          break;
        default:
          alert('Invalid Button Type');
          return;
      }
      window.open(url, '_blank'); // Open the URL in a new tab
    } else {
      alert('GBRN or INCHIKEY is missing or invalid!');
    }
  }

  displayMap: { [key: string]: boolean } = {};

  getcolumnsdiscovery() {
    this.datasearch.getdropdown().subscribe(
      (res: any) => {
        // ✅ Extract columns array safely for new API format
        const columnsArray = Array.isArray(res?.data?.results)
          ? res.data.results
          : Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
          ? res
          : null;

        if (!columnsArray) {
          console.error('🚫 Invalid dropdown response structure:', res);
          return;
        }

        this.columns = columnsArray;
        this.displayMap = {};

        for (const col of columnsArray) {
          // ✅ Use 'field' as column name (since new API uses 'field', not 'tableColumnName')
          const colName = col?.field ?? 'UNKNOWN';
          const isDisplayed = Number(col?.isDisplay) === 1;
          this.displayMap[colName] = isDisplayed;
        }
      },
      (error) => {
        console.error('❌ Error fetching dropdown data:', error);
      }
    );
  }

  isColumnVisible(item: any, key: string): boolean {
    return this.displayMap[key] && !!item[key];
  }
}
